import {Component, computed, input} from '@angular/core';
import {ManageTaBaseComponent} from '../manage-ta-base-component.directive';
import {Button} from 'primeng/button';
import {DatePipe} from '@angular/common';
import {TaCostBubbleComponent} from '../../ta-cost-bubble/ta-cost-bubble.component';
import {
  ItineraryDifferenceComparisonComponent
} from '../itinerary-difference-comparison/itinerary-difference-comparison.component';

@Component({
  selector: 'manage-ta-info',
  imports: [
    Button,
    DatePipe,
    TaCostBubbleComponent,
    ItineraryDifferenceComparisonComponent
  ],
  templateUrl: './manage-ta-info.component.html',
  styleUrl: './manage-ta-info.component.scss'
})
export class ManageTaInfoComponent extends ManageTaBaseComponent {
  message = input<string>('');
}
